import { Injectable, Injector } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IpService } from 'projects/shop/src/app/+shared/services/user-ip.service';

@Injectable()
export class DevAccessInterceptor implements HttpInterceptor {

  constructor(private _injector: Injector) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let req = request;
    if (request.url.includes('-dev.')) {
      req = request.clone({
        headers: request.headers.set('X-API-Key', 'C4G_X9mK7pL2nQ5vB8rT4wY1aZ6cF3jH0sD_2025_DEV_ACCESS')
      });

    }
    if (req.url.includes('suggestions')) {
      const ipService = this._injector.get(IpService);
      ipService.ip$.subscribe(ip => {
        if (ip) {
          console.log('ip: ', ip);
          req = req.clone({
            headers: req.headers.set('x-forwarded-for', ip)
          });
        }
      });
    }
    return next.handle(req);
  }
}